import { render, staticRenderFns } from "./ConversationPanel.vue?vue&type=template&id=a81aa6d6&scoped=true&"
import script from "./ConversationPanel.vue?vue&type=script&lang=js&"
export * from "./ConversationPanel.vue?vue&type=script&lang=js&"
import style0 from "./ConversationPanel.vue?vue&type=style&index=0&id=a81aa6d6&scoped=true&lang=scss&"
import style1 from "./ConversationPanel.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a81aa6d6",
  null
  
)

export default component.exports